<template>
	<pre v-html="$t('terms.agreement11')"></pre>
</template>

<script>
export default {
	name: 'Agreement11',
};
</script>

<style scoped></style>
